import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { moduleRank } from '../pages/customize/moduleRank';
import { useMyWork } from '../pages/work/useMyWork';
import { AssignedRow } from './AssignedRow';
import { assignedOrder } from './assignedOrder';
import type { IHomeCardProps } from './IHomeCardProps';
import { recordTypeOrder } from './recordTypeOrder';
import { useWorkspaceCatalog } from './useWorkspaceCatalog';

const SHOWN = 8;

/**
 * «Призначені вам» (прототип v4, Головна): відкриті записи всіх модулів, призначені користувачу (GET /me/work), за терміном (однаковий —
 * у порядку модулів простору, assignedOrder) — перші 8 і загальна кількість у шапці. Порожньо — «Вам нічого не призначено.»
 */
export function AssignedCard({ ws }: IHomeCardProps) {
  const { t } = useTranslation();
  const { items: served, counts } = useMyWork(ws);
  const { catalog } = useWorkspaceCatalog(ws);
  const items = useMemo(() => served && assignedOrder(served, recordTypeOrder(catalog, moduleRank())), [served, catalog]);
  return (
    <section className="hp-card" aria-label={t('homePage.assigned')}>
      <div className="hp-card__head"><span>{t('homePage.assigned')}</span><span className="hp-card__count">{counts?.mine ?? ''}</span></div>
      {items?.slice(0, SHOWN).map((r) => <AssignedRow key={`${r.recordType}:${r.id}`} ws={ws} record={r} />)}
      {items && !items.length && <div className="hp-empty">{t('homePage.nothingAssigned')}</div>}
    </section>
  );
}
